import { jsxs as e, jsx as r } from "react/jsx-runtime";

import { useMemo as t } from "react";

import { eachDayOfInterval as a, endOfWeek as l, startOfWeek as s, getHours as o, eachHourOfInterval as i, addHours as n, setHours as d, endOfDay as m, startOfDay as c, isSameDay as p, format as h } from "date-fns";

import u from "@ui-components-3/ui/lib/utils/classNames";

import f from "./WeekCalendarHourRow.js";

import { useProviderSchedule as b } from "../../../hooks/useProviderSchedule.js";

import { orderBy as g } from "lodash";

import { SCHEDULE_WEEK_STARTS_ON as x, calendarWeekDays as v, SCHEDULE_DATE_FORMAT as w } from "../../../utils.js";

const y = "min-w-[1025px]", N = u("grid-cols-[80px_1fr]", y), k = () => {
    const {date: k, variantClassNames: j, slots: D} = b(), M = t((() => a({
        start: s(k, {
            weekStartsOn: x
        }),
        end: l(k, {
            weekStartsOn: x
        })
    })), [ k ]), $ = t((() => D?.length ? Math.min(g(D.map((e => ({
        hour: o(new Date(e.startTime))
    }))), [ "hour" ], [ "asc" ])?.[0]?.hour || 0, 7) : 7), [ D ]), C = i({
        start: d(c(new Date), $ || 0),
        end: n(m(new Date), 1)
    });
    return e("div", {
        className: u("typography-body flex flex-col gap-6 overflow-x-auto", j.textMainDark),
        "aria-label": "Week Calendar",
        children: [ e("div", {
            className: u("grid", N),
            children: [ r("div", {
                className: "sticky left-0 bg-white"
            }), r("div", {
                className: "grid grid-cols-7",
                children: M.map(((t, a) => {
                    const l = v[a], s = p(new Date, t), o = `${h(t, w)}${s ? ", Today" : ""}`;
                    return r("div", {
                        "aria-label": o,
                        children: e("div", {
                            className: "flex h-full min-h-[80px] flex-col items-center gap-2 p-3 pb-0 text-center",
                            children: [ r("h6", {
                                className: u("typography-body-l uppercase tracking-normal", s ? u(j.textMain, "font-semibold") : "font-medium"),
                                children: l
                            }), r("p", {
                                className: u("typography-body-xl text-center tracking-normal", s ? u(j.bgMain, "inline-flex h-9 w-9 items-center justify-center rounded-full font-bold text-white ") : "font-semibold text-neutral-600"),
                                children: h(t, "d")
                            }) ]
                        })
                    }, l);
                }))
            }) ]
        }), e("div", {
            className: "relative",
            children: [ C.map(((e, t) => {
                const a = h(e, "h a");
                return r(f, {
                    formattedHour: a,
                    days: M,
                    className: N,
                    isEmpty: t === C.length - 1,
                    zIndex: C.length - t
                }, `${a}_${t}`);
            })), r("div", {
                className: u("pointer-events-none absolute left-0 top-0 z-0 h-full w-full pl-[80px]", y),
                children: r("div", {
                    className: "h-full w-full border-l border-t border-neutral-300 bg-transparent",
                    children: C.map(((e, t) => r("div", {
                        className: "grid w-full grid-cols-7 border-b border-neutral-300",
                        style: {
                            height: 100 / C.length + "%"
                        },
                        children: v.map(((e, t) => r("div", {
                            className: "border-r border-neutral-300"
                        }, t)))
                    }, t)))
                })
            }) ]
        }) ]
    });
};

export { k as default };
//# sourceMappingURL=index.js.map
